import * as React from 'react';

const SvgArrow = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width}
    height={props.width}
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <g mask='url(#mask0_940_108)'>
      <path
        d='M12.0008 14.9748C11.8674 14.9748 11.7424 14.954 11.6258 14.9123C11.5091 14.8706 11.4008 14.7998 11.3008 14.6998L6.70078 10.0998C6.51745 9.91647 6.42578 9.68314 6.42578 9.3998C6.42578 9.11647 6.51745 8.88314 6.70078 8.6998C6.88411 8.51647 7.11745 8.4248 7.40078 8.4248C7.68411 8.4248 7.91745 8.51647 8.10078 8.6998L12.0008 12.5998L15.9008 8.6998C16.0841 8.51647 16.3174 8.4248 16.6008 8.4248C16.8841 8.4248 17.1174 8.51647 17.3008 8.6998C17.4841 8.88314 17.5758 9.11647 17.5758 9.3998C17.5758 9.68314 17.4841 9.91647 17.3008 10.0998L12.7008 14.6998C12.6008 14.7998 12.4924 14.8706 12.3758 14.9123C12.2591 14.954 12.1341 14.9748 12.0008 14.9748Z'
        fill='#F4F2F2'
      />
    </g>
  </svg>
);

export default SvgArrow;
